import { render, staticRenderFns } from "./CSSLabEventsPage.vue?vue&type=template&id=109dc92f&scoped=true"
import script from "./CSSLabEventsPage.vue?vue&type=script&lang=js"
export * from "./CSSLabEventsPage.vue?vue&type=script&lang=js"
import style0 from "./CSSLabEventsPage.vue?vue&type=style&index=0&id=109dc92f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "109dc92f",
  null
  
)

export default component.exports